goog.provide('el8.appanalytics.dialog.viewMuNumDen');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appanalytics.dialog.viewMuNumDen');
goog.require('el8.uiwidget.TabbedNav');
goog.require('el8.app.pageLayout');


el8.appanalytics.dialog.viewMuNumDen = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: "",
        modal: true,
        height: function() {
            return el8.app.pageLayout.getAppHeight() - 100;
        },
        width: 650,
        contentFn: el8.template.appanalytics.dialog.viewMuNumDen.content,
        showXButton: true
    });

    var super_show = that.show;
    var nd;
    that.show = function(spec) {
        spec = spec || {};
        nd = {};
        nd.done = [];
        super_show.call(that);
        $('.view-mu-num-den-content', that.getContentElt()).html(
            el8.template.appanalytics.dialog.viewMuNumDen.details({
                header: spec.title,
                csvUrl: spec.csvUrl,
                measure: spec.description
            })
        );
        initTabs(spec);
    };

    function loadNumDenData(spec) {
        if (nd.done.indexOf('num') >= 0 && nd.done.indexOf('den') >= 0) {
            spec.success(nd.numData, nd.denData, nd.denNotNumData);
            return;
        }
        var partDone = function(name) {
            nd.done.push(name);
            if (nd.done.indexOf('num') >= 0 && nd.done.indexOf('den') >= 0) {
                if (nd.numData &&
                    nd.denData &&
                    nd.denData.length) {
                    nd.denNotNumData = [];
                    for (var i=0; i<nd.denData.length; i++) {
                        var item = nd.denData[i];
                        var isNotNum = !$.grep(nd.numData, function(numItem) { return numItem.id === item.id; }).length;
                        if (isNotNum) {
                            nd.denNotNumData.push(item);
                        }
                    }
                }
                spec.success(nd.numData, nd.denData, nd.denNotNumData);
                return;
            }
        };
        // fetch the numerator
        if (spec.numUrl) {
            $.el8_ajax({
                type: 'GET',
                url: spec.numUrl,
                success: function(data) {
                    nd.numData = data;
                    partDone('num');
                }
            });
        } else {
            nd.numData = [];
            partDone('num');
        }
        // fetch the denominator
        if (spec.denUrl) {
            $.el8_ajax({
                type: 'GET',
                url: spec.denUrl,
                success: function(data) {
                    nd.denData = data;
                    partDone('den');
                }
            });
        } else {
            nd.denData = [];
            partDone('den');
        }
    }

    function initTabs(spec) {

        var numUrl = spec.numUrl;
        var denUrl = spec.denUrl;

        var isMeetsLoaded = false;
        var isNotMeetsLoaded = false;

        var tabbedNav = new el8.uiwidget.TabbedNav();
        tabbedNav.init({wrapper: $('.tabbed-nav', that.getContentElt())});
        tabbedNav.addTab({
            title: 'Does Not Meet Criteria',
            name: 'not-meet',
            contentDiv: $('.not-meet-criteria-list', that.getContentElt()),
            showTabFn: function() {
                if (!isNotMeetsLoaded) {
                    isNotMeetsLoaded = true;
                    var $elt = $('.not-meet-criteria-list', that.getContentElt());
                    $elt.addClass('feedLoading');
                    loadNumDenData({
                        numUrl: numUrl,
                        denUrl: denUrl,
                        success: function(numData, denData, denNotNumData) {
                            var data = denNotNumData || [];
                            $elt.html(
                                el8.template.appanalytics.dialog.viewMuNumDen.list({
                                    list: data
                                })
                            ).removeClass('feedLoading');
                        }
                    });
                }
            }
        });
        tabbedNav.addTab({
            title: 'Meets Criteria',
            name: 'meet',
            contentDiv: $('.meet-criteria-list', that.getContentElt()),
            showTabFn: function() {
                if (!isMeetsLoaded) {
                    isMeetsLoaded = true;
                    var $elt = $('.meet-criteria-list', that.getContentElt());
                    $elt.addClass('feedLoading');
                    loadNumDenData({
                        numUrl: numUrl,
                        denUrl: denUrl,
                        success: function(numData, denData, denNotNumData) {
                            var data = numData || [];
                            $elt.html(
                                el8.template.appanalytics.dialog.viewMuNumDen.list({
                                    list: data
                                })
                            ).removeClass('feedLoading');
                        }
                    });
                }
            }
        });
        tabbedNav.showTab('not-meet');
    }

    return that;

})();


